<template>
    <div class="user-filter-component">
        <div v-if="!formOpened">
            <div class="select-component">
                <multiselect
                    class="select-component"
                    :placeholder="t('Select')"
                    :options="availableValues"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    track-by="id"
                    label="name"
                    :loading="loading"
                    v-model="value"
                    @open="onOpen"
                    @input="onInput"
                >
                    <div slot="noOptions">{{ t('List is empty') }}</div>
                </multiselect>
            </div>
            <button @click="openForm" class="btn btn-success btn-sm add-button">+</button>
        </div>

        <div v-if="formOpened" class="save-panel">
            <div class="row">
                <div class="col-lg-12 col-sm-12 col-md-12">
                    <label for="name">{{ t('Short name') }}</label>
                    <input type="text" :placeholder="t('Type search name to save')" v-model="name" class="form-control user-filter-value" :class="errorClass">
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 col-sm-12 col-md-12">
                    <button @click="save" class="btn btn-success btn-sm" style="float: right;">{{ t('Save') }}</button>
                    <a href="#" @click="closeForm" class="btn btn-success btn-sm btn-link" style="float: right;">{{ t('Cancel') }}</a>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import Multiselect from "@/components/Multiselect.vue";

export default {
    components: {Multiselect},
    props: {
        componentFilterIndex: {
            type: String
        },
        eventBus: {
            Type: Object,
        },
        moduleName: {
            type: String
        },
        config: {
            type: Object,
            default: function () {
                return {
                    name: null,
                    loadUrl: null,
                };
            }
        }
    },
    data() {
        return {
            value: [],
            loading: false,
            availableValues: [],
            formOpened: false,
            name: null,
            defaultValues: [],
            filterState: [],
            loadUrl: null,
            errorClass: null,
        };
    },
    beforeDestroy() {
        this.unmountEvents();
    },
    inject: ['eventManager'],
    mounted() {
        this.init();
        this.mountEvents();
    },
    methods: {
        init() {
            this.componentIndex = this.config.index;
        },
        async onOpen() {
            if (0 < this.availableValues.length) {
                return;
            }

            this.loading = true;
            let response = await this.getAvailableValues({views: this.moduleName});
            this.availableValues = response.data.data;
            this.loading = false;
        },
        async onInput() {
            let values = JSON.parse(this.value.values);

            if (!values) {
                return;
            }

            this.eventManager.emitEvents(this.config.emitEvents['change'] || [], values);
        },
        mountEvents() {
            this.eventManager.bindEvents(this.defaultBindEvents(), this);
        },
        defaultBindEvents() {
            return [{
                name: 'setFilterState',
                componentIndex: this.componentIndex,
            }];
        },
        async getAvailableValues(params) {
            const url = this.config['loadUrl'];

            return await this.$http['get'](url, {params: params});
        },
        openForm() {
            this.formOpened = true;
        },

        closeForm() {
            this.formOpened = false;
            this.errorClass = null;
        },
        validate() {
            this.errorClass = null;

            if (!this.name) {
                this.errorClass = 'errorClass';
                return false;
            }

            return true;
        },
        async save() {
            if (!this.validate()) {
                return;
            }

            const data = {
                name: this.name,
                values: this.filterState,
                module: this.moduleName
            };

            const saveUrl = this.config['saveUrl'];
            await this.$http.post(saveUrl, data);
            this.availableValues = [];
            this.name = null;
            this.closeForm();
        },

        setFilterState(eventData, state) {
            this.filterState = state;
        },
        unmountEvents() {
            this.eventManager.unbindEvents(this.defaultBindEvents());
        },
    },
}
</script>

<style lang="sass" scoped>
    .user-filter-component {
        position: relative;
    }
    .select-component {
        float: left;
        min-width: 300px!important;
        margin-top: -5px;
    }
    .user-filter-value {
        margin-bottom: 3px;
        min-width: 400px!important;
    }
    .add-button {
        margin-left: 3px;
        margin-top: -4px;
    }
    .errorClass {
        border: 1px solid red;
    }
    label {
        font-size: 0.8em;
    }
    .save-panel button {
        border-radius: 12px;
    }
    .save-panel {
        position: absolute;
        top: 0;
        right: 0;
        background-color: white;
        padding: 15px;
        border-radius: 12px;
        z-index: 99999!important;
        border-left: #48E04A 5px solid;
        box-shadow: 10px 12px 10px 6px #0000003f;
    }
</style>



// WEBPACK FOOTER //
// UserFilterComponent.vue?25596478